import { render, staticRenderFns } from "./ChangeMassTermModuleSlidebar.vue?vue&type=template&id=44162bb3"
import script from "./ChangeMassTermModuleSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeMassTermModuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports